import { render } from "./ReEshop.vue?vue&type=template&id=8ca1f4aa"
import script from "./ReEshop.vue?vue&type=script&lang=js"
export * from "./ReEshop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__